import ReportsTab, {ReportsTabExtensionProps} from 'modules/reports/components/Tab'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
// import useStyles from './ReportsEditViewTab.styles'
import ReportsEditSection from 'modules/reports/components/Edit/Section'
import ReportsEditList from 'modules/reports/components/Edit/List'

type Props = ReportsTabExtensionProps & {}

function ReportsEditViewTab(props: Props) {
  // const classes = useStyles()
  const {p, pt} = useCore('reports', 'tabs', 'EditView')

  const items = [{}, {}, {}, {}]

  return (
    <ReportsTab {...props} label={pt('label')} data-testid={p()}>
      <ReportsEditSection title={pt('group-by')} data-testid={p('group-by')}>
        <ReportsEditList items={items} data-testid={p('group-by-list')} />
      </ReportsEditSection>

      <ReportsEditSection title={pt('columns')} data-testid={p('columns')}>
        <ReportsEditList items={items} data-testid={p('columns')} />
      </ReportsEditSection>
    </ReportsTab>
  )
}

export default ReportsEditViewTab
